import { Formik } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { TextField, Box, Button } from 'components/ui';
import { WideForm } from 'components/styles_components/form';
import validationSchema from 'validation/billing_details/create';

const Form = ({ onSubmit, onCancel, processing, initialValues }) => {
  const intl = useIntl();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema(intl)}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isValid, dirty }) => (
        <WideForm onSubmit={handleSubmit}>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            id="name"
            name="name"
            label={intl.formatMessage({ id: 'billing_details.name' }) + ' *'}
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={(touched.name && Boolean(errors.name)) || undefined}
            helperText={touched.name && errors.name}
          />
          <TextField
            fullWidth
            margin="dense"
            id="address"
            name="address"
            label={intl.formatMessage({ id: 'billing_details.address' }) + ' *'}
            value={values.address}
            onChange={handleChange}
            onBlur={handleBlur}
            error={(touched.address && Boolean(errors.address)) || undefined}
            helperText={touched.address && errors.address}
          />
          <TextField
            fullWidth
            margin="dense"
            id="zipCode"
            name="zipCode"
            label={intl.formatMessage({ id: 'billing_details.zip_code' }) + ' *'}
            value={values.zipCode}
            onChange={handleChange}
            onBlur={handleBlur}
            error={(touched.zipCode && Boolean(errors.zipCode)) || undefined}
            helperText={touched.zipCode && errors.zipCode}
          />
          <TextField
            fullWidth
            margin="dense"
            id="city"
            name="city"
            label={intl.formatMessage({ id: 'billing_details.city' }) + ' *'}
            value={values.city}
            onChange={handleChange}
            onBlur={handleBlur}
            error={(touched.city && Boolean(errors.city)) || undefined}
            helperText={touched.city && errors.city}
          />
          <TextField
            fullWidth
            margin="dense"
            id="taxId"
            name="taxId"
            label={intl.formatMessage({ id: 'billing_details.tax_id' })}
            value={values.taxId}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <TextField
            fullWidth
            margin="dense"
            id="email"
            name="email"
            label={intl.formatMessage({ id: 'billing_details.email' })}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Button
            fullWidth
            className="margin-top-10"
            disabled={!isValid || processing || !dirty}
            color="primary"
            variant="contained"
            type="submit"
          >
            <FormattedMessage id="button.save" />
          </Button>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="text" size="small" disabled={processing} onClick={onCancel}>
              <FormattedMessage id="button.cancel" />
            </Button>
          </Box>
        </WideForm>
      )}
    </Formik>
  );
};

export default Form;
